"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwToggleButton = _interopRequireDefault(require("./CwToggleButton.scss"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CwImage = _interopRequireDefault(require("../cwimage/CwImage"));

var CwToggleButton =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(CwToggleButton, _React$Component);

  function CwToggleButton() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, CwToggleButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(CwToggleButton)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClick", function () {
      if (!_this.props.onClick) {
        return;
      }

      _this.props.onClick(_this.props.item);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleKeyPress", function (event) {
      if (!_this.props.onClick || event.which !== 32) {
        return;
      }

      _this.props.onClick(_this.props.item);
    });
    return _this;
  }

  (0, _createClass2.default)(CwToggleButton, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var value = this.props.value;
      var btnClass = value ? _CwToggleButton.default.innerActive : _CwToggleButton.default.innerEnabled;
      return _react.default.createElement("div", {
        "data-cwid": this.props.cwId,
        onBlur: this.props.onBlur,
        style: this.props.style,
        className: this.props.className ? (0, _classnames.default)(_CwToggleButton.default.wrap, this.props.className) : _CwToggleButton.default.wrap,
        tabIndex: this.props.tabIndex,
        onClick: this.handleClick,
        onKeyPress: this.handleKeyPress,
        onKeyDown: this.handleKeyDown,
        onKeyUp: this.handleKeyUp,
        ref: function ref(input) {
          return _this2.cwButton = input;
        },
        onFocus: this.props.onFocus
      }, _react.default.createElement("div", {
        className: btnClass
      }, this.props.icon ? _react.default.createElement(_CwImage.default, {
        src: this.props.icon
      }) : null, this.props.text, this.props.rightIcon ? _react.default.createElement(_CwImage.default, {
        src: this.props.rightIcon
      }) : null));
    }
  }]);
  return CwToggleButton;
}(_react.default.Component);

CwToggleButton.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes.default.string,

  /**
   * Text next to checkbox
   */
  text: _propTypes.default.string,

  /**
   * Callback function when checkbox value is changed
   */
  onChange: _propTypes.default.func,

  /**
   * Used to check a checkbox
   */
  value: _propTypes.default.bool,

  /**
   * Used to control tab order
   */
  tabIndex: _propTypes.default.number,

  /**
   * Callback function that is fired when the component is focused
   */
  onFocus: _propTypes.default.func,

  /**
   * Callback function that is fired when the component is blurred
   */
  onBlur: _propTypes.default.func,

  /**
   * Optional icon placed on right side of button
   */
  rightIcon: _propTypes.default.string,

  /**
   * Optional icon placed on left side of button
   */
  icon: _propTypes.default.string,

  /**
   * Object of with id, name used to identify the toggle button
   */
  item: _propTypes.default.shape({
    id: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.bool]),
    name: _propTypes.default.string
  }),

  /**
   * Unused, added to satisfy pod element check
   */
  invalid: _propTypes.default.bool
};
CwToggleButton.defaultProps = {
  tabIndex: 0
};
var _default = CwToggleButton;
exports.default = _default;